/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Stage_Article_MetaInputs */

const en_directory_submit_enrich_stage_article_meta = /** @type {(inputs: Directory_Submit_Enrich_Stage_Article_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Article meta`)
};

const zh_directory_submit_enrich_stage_article_meta = /** @type {(inputs: Directory_Submit_Enrich_Stage_Article_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成元数据`)
};

/**
* | output |
* | --- |
* | "Article meta" |
*
* @param {Directory_Submit_Enrich_Stage_Article_MetaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_stage_article_meta = /** @type {((inputs?: Directory_Submit_Enrich_Stage_Article_MetaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Stage_Article_MetaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_stage_article_meta(inputs)
	return zh_directory_submit_enrich_stage_article_meta(inputs)
});
export { directory_submit_enrich_stage_article_meta as "directory.submit.enrich.stage.article_meta" }